<template>
  <div id="page-product-details">
    <FDO-form
        ref="form"
        v-model="model"
        :facility-id="id"
        :loading="loading"
        card-title="Create FDO"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'facilities.fdos.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="create"
              class="my-4"
              color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from '@/components/mixins/NotificationMixin';
import FDOForm from '@/views/pages/facilities/fdos/FDOForm';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';

export default {
  name: 'FDOCreate',
  components: {
    FDOForm,
  },
  mixins: [NotificationMixin, SaveModelMixin],
  data() {
    return {
      model: {},
      modelEntity: this.$api.facilities.fdos,
      entity: 'FDO',
      loading: false,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);

      const dates = [
        'InceptionDate',
        'ExpiryDate'
      ];

      const references = [
        'Market_FK'
      ];

      const multiReferences = [{
        array: 'sections',
        key: ['Section_FK'],
      }];

      this.setDates(dates);
      this.setReferences(references);
      this.setMultiReferences(multiReferences);

      params.underwriters.forEach((underwriter) => {
        this.setReferences(['CompanyInsurer_FK', 'InsurerRole_FK'], underwriter);
        // Not needed
        underwriter.sections.forEach((section) => delete section.Section);
      });

      params.Facility_FK = this.id;

      return params;
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      const params = this.getParams();

      if (!this.validateParams(params)) {
        return false;
      }

      this.loading = true;

      //  return;
      try {
        const {data} = await this.$api.facilities.fdos.create(params);
        this.notifySuccess('FDO created');
        this.$router.back();
      } catch (e) {
        this.notifyError('FDO failed to be created');
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    validateParams({underwriters, sections}) {
      if (sections.length === 0) {
        this.notifyError('At least one section is required.');
        return false;
      }

      if (underwriters.length === 0) {
        this.notifyError('At least one underwriter is required.');
        return false;
      }

      return true;
    }
  },
};
</script>

<style scoped>

</style>
